module.exports = __webpack_public_path__ + "img/citrix.a09e365f.webp";